interface Props {
  onClick: () => void;
  /** Where it goes, for assistive tech. The arrow alone says nothing. */
  label: string;
}

/**
 * Back control for the in-game top bar.
 *
 * The game screens are full-height with a fixed action bar, so there is nowhere
 * in the flow for a "Back" link — and the action bar's own buttons are disabled
 * until the player has accused something, which left someone who opened a case
 * and changed their mind with no control that did anything at all.
 *
 * It sits in the top bar rather than the HUD deliberately: the HUD is where
 * committing happens, and putting "leave" next to "submit" invites the wrong
 * tap. Top-left is also where a phone user already looks for back.
 */
export function BackButton({ onClick, label }: Props) {
  return (
    <button type="button" className="topbar__back" onClick={onClick} aria-label={label}>
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M15 5 L8 12 L15 19"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
